module.exports = __webpack_public_path__ + "static/media/Illustration.ccb78156.png";